export interface IntegrationAuthenticationStatusConnected {
    type: 'CONNECTED';
}

export function createIntegrationAuthenticationStatusConnected(): IntegrationAuthenticationStatusConnected {
    return {
        type: 'CONNECTED',
    };
}
